import React from 'react';
import PropTypes from 'prop-types';

import { WithIconRounded } from 'Components/ProfileMultiProduct/components/designSystem';
import StaticLoaderIconSVG from './StaticLoaderIconSVG';

function StaticLoaderIcon({
  round,
  containerColor,
  containerSize,
  color,
  size,
  onClick,
  className,
}) {
  return (
    <WithIconRounded
      round={round}
      containerColor={containerColor}
      containerSize={containerSize}
      className={className}
      onClick={onClick}
    >
      <StaticLoaderIconSVG size={size} color={color} />
    </WithIconRounded>

  );
}


StaticLoaderIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  containerColor: PropTypes.string,
  containerSize: PropTypes.number,
  onClick: PropTypes.func,
  round: PropTypes.bool,
  size: PropTypes.number,
};

StaticLoaderIcon.defaultProps = {
  className: 'k-ds-bg-color-light-grey-300',
  color: 'var(--k-ds-color-grey-900)',
  containerColor: null,
  containerSize: 40,
  onClick: null,
  round: false,
  size: 14,
};

export default StaticLoaderIcon;
